import { GameUIConfig } from "../GameConfig/GameConfig.js";

export default class BulletUI {
  constructor() {
    this.image = new Image();
    this.image.src = GameUIConfig.BulletUI.IMG_SRC;

    this.spriteWidth = GameUIConfig.BulletUI.SPRITE_WIDTH;
    this.spriteHeight = GameUIConfig.BulletUI.SPRITE_HEIGHT;

    this.x = GameUIConfig.BulletUI.X;
    this.y = GameUIConfig.BulletUI.Y;

    this.textX = GameUIConfig.BulletUI.TEXT_X;
    this.textY = GameUIConfig.BulletUI.TEXT_Y;

    this.bulletCount = 0;
  }
  draw(context) {
    context.drawImage(
      this.image,
      0,
      0,
      this.spriteWidth,
      this.spriteHeight,
      this.x,
      this.y,
      this.spriteWidth,
      this.spriteHeight,
    );

    context.fillStyle = "#ffc40c";
    context.fillRect(
      this.textX,
      this.textY + (this.spriteHeight * 1) / 5,
      this.bulletCount,
      20,
    );
  }

  update(bullets) {
    this.bulletCount = bullets;
  }
}
